<template>
  <div class="image-upload" v-bind="$attrs" @dragover.prevent @drop.prevent @click="onClick">
    <img v-if="image" :src="image" alt="">
    <label class="image-upload__area"  @drop="drop">
      <input class="image-upload__file" type="file" @change="change" ref="file">
      <div class="image-upload__icon" v-if="!image">
        <Icon :name="icon" />
      </div>
    </label>
  </div>
  <span class="image-upload__title" v-if="title">{{ title }}</span>
</template>
  
  
<style lang="scss">
.image-upload {
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-self: baseline;
  border-radius: 50%;
  min-height: 100px;
  min-width: 100px;
  max-width: 100%;
  background: var(--background);
  border: 1px solid var(--border);

  &--wide {
    width: 100%;
    border-radius: 6px;
  }

  img[src*="/content/user/"] {
    height: 100px;
    object-fit: cover;
    border-radius: 50%;
  }

  &__title {
    display: flex;
    justify-content: center;
    margin-bottom: 10px;
  }

  &__area {
    cursor: pointer;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    // &:hover {
    //   background: #000;
    //   opacity: .3;
    // }
  }

  &__icon {
    position: absolute;
    width: 100%;
    height: 100%;
    align-items: center;
    font-size: 40px;
    display: flex;
    justify-content: center;
  }

  &__file {
    display: none;
  }

  &__btn {
    position: absolute;
    top: 5px;
    right: 5px;
    height: 20px;
    width: 20px;
  }
}
</style>
  
  <script>
  import store from '@/store'

  const convertURLtoFile = async (url) => {
      const response = await fetch(url);
      const data = await response.blob();
      const filename = url.split("/").pop();
      const metadata = { type: `image/jpeg` };
      return new File([data], filename, metadata);
  };

  export default {
    props: {
      modelValue: null,
      title: null,
      icon: {
        type: String,
        default: 'image'
      }
    },
    data() {
      return {
        file: null
      }
    },
    mounted() {
      if (window.Flutter) {
          window.Flutter.postMessage('openImagePicker')
        }
    },
    computed: {
      image() {
        console.log(this.modelValue)
        if(!this.modelValue) return false;
  
        if(typeof this.modelValue == 'object') {
          return URL.createObjectURL(this.modelValue);
        }
          
        return this.modelValue;
      }
    },
    methods: {
      onClick() {
        //store.dbg = 23121;
      },
      sendFile(file) {
        this.$emit('update:modelValue', file);
        this.$emit('upload', file);
        this.file = file
      },
      drop(e) {
        this.sendFile(e.dataTransfer.files[0])
      },
      change() {
        this.sendFile(this.$refs.file.files[0]);
      }
    }
  }
</script>